import './FeedbackOverview.css';
import { PrimaryButton } from "../../../../components/Modules/PrimaryButton";

import { CSSProperties } from 'react';
import { GeneralFeedbackContentStyleConfig } from '../components/FeedbackWorkflowApi';
import NormalInput from './NormalInput';
import EmailInput from './EmailInput';
import TextAreaInput from './TextAreaInput';
import RatingInput from './RatingInput';
import ImageInput from './ImageInput';

interface BugContentProps {
    formdata: any;
    handleSubmit: () => void
    handleUpdate: (e: any, id: string, j: string, k?: number) => void;
    answer: any;
    handleRemove: ((e: any) => void) | undefined
    // normalInput: (question: string, criteriaId: string, placeholder?: string, required?: boolean) => JSX.Element,
    // emailInput: (question: string, criteriaId: string, placeholder?: string, required?: boolean) => JSX.Element,
    // normalInput2: (question: string, criteriaId: string, placeholder?: string, required?: boolean) => JSX.Element,
    buttonStyle?: CSSProperties;
    PrimaryButtonText?: string;
    labelStyle?: CSSProperties,
    ratingStyle?: "Star" | "Numbers" | "Smiles";
    StarStyle?: {
        Style?: React.CSSProperties;
        PrimaryColor?: string;
        SecondaryColor?: string;
        Size?: number;
    }
    isVisible: boolean | undefined;
    setIsVisible: Function | undefined;
    screenshot: FileProp | null | undefined;
    onStartCapture: () => void;
    setScreenshot: ((screenshot: FileProp | null) => void) | undefined
    uploadFileToBackend: (file: any) => any;
    inputRef: React.MutableRefObject<HTMLInputElement | null>;
    file: FileProp | null;
    setFile: (file: FileProp | null) => any;
    styleConfig?: GeneralFeedbackContentStyleConfig;
    BrandTheme?: BrandTheme;
    rating: number;
    setRating: (rating: number) => void
    starBorderColor: string
}
interface FileProp {
    name: string;
    size: number;
    type: string;
    lastModified: number;
    webkitRelativePath: string;
}
type BrandTheme = {
    accentColor?: string;
    background?: string;
    borderRadius?: string;
    primaryButton?: string;
    secondaryButton?: string;
    contentColor?: string;
    fontFamily?: string;
    logo?: string;
    primaryColor?: string;
    secondaryColor?: string;
    tertiaryColor?: string;
    titleColor?: string;
}
const BugContent: React.FC<BugContentProps> = ({
    formdata,
    handleSubmit,
    buttonStyle = {},
    PrimaryButtonText = "Submit",
    labelStyle,
    ratingStyle,
    handleUpdate,
    StarStyle,
    isVisible,
    setIsVisible,
    screenshot,
    setScreenshot,
    onStartCapture,
    uploadFileToBackend,
    inputRef,
    file,
    setFile,
    answer,
    rating,
    setRating,
    starBorderColor
}) => {
    const handleRatingChange2 = (e: any, id: any, rating: number) => {
        setRating(rating);
        handleUpdate(e, id, '', rating);
    };

    const handleUploadImages = async (e: any) => {
        e.preventDefault();
        let urlArr = [];
        if (file !== null) {
            let URL = await uploadFileToBackend(file);
            urlArr.push(URL);
        }
        if (screenshot !== null) {
            let URL = await uploadFileToBackend(screenshot);
            urlArr.push(URL);
        }
        for (let i = 0; i < formdata.length; i++) {
            if (formdata[i].type === "USER_INPUT_IMAGE") {
                answer[formdata[i].criteriaId] = urlArr;
                break;
            }
        }
        handleSubmit();
        setFile(null);
        setScreenshot && setScreenshot(null);
    };

    return (
        <form className='q-fdov-ch-boxes' onSubmit={handleUploadImages}>
            {formdata?.length > 0 ? (
                <>
                    {formdata.map((data: any) => {
                        if (data.type === 'USER_INPUT_TEXT') {
                            return <>
                                <NormalInput
                                    question={data.question || ""}
                                    criteriaId={data.criteriaId || ""}
                                    placeholder={data.placeholder || ""}
                                    required={data.required || false}
                                    answer={answer}
                                    handleUpdate={handleUpdate}
                                />
                            </>
                        } else if (data.type === 'USER_INPUT_EMAIL') {
                            return <>
                                <EmailInput
                                    question={data.question || ""}
                                    criteriaId={data.criteriaId || ""}
                                    placeholder={data.placeholder || ""}
                                    required={data.required || false}
                                    answer={answer}
                                    handleUpdate={handleUpdate}
                                    feedbackType={"ReportBug"}
                                />
                            </>
                        } else if (data.type === 'USER_INPUT_TEXTAREA') {
                            return <>
                                <TextAreaInput
                                    question={data.question || ""}
                                    criteriaId={data.criteriaId || ""}
                                    placeholder={data.placeholder || ""}
                                    required={data.required || false}
                                    answer={answer}
                                    handleUpdate={handleUpdate}
                                    feedbackType={"ReportBug"}
                                />
                            </>
                        }
                        else if (data.type === 'RATING') {
                            return <>
                                <RatingInput
                                    data={data}
                                    labelStyle={labelStyle}
                                    StarStyle={StarStyle}
                                    ratingStyle={ratingStyle}
                                    rating={rating}
                                    handleRatingChange2={handleRatingChange2}
                                    starBorderColor={starBorderColor}
                                />
                            </>
                        } else if (data.type === "USER_INPUT_IMAGE") {
                            return <>
                                <ImageInput
                                    screenshot={screenshot}
                                    setIsVisible={setIsVisible}
                                    isVisible={isVisible}
                                    onStartCapture={onStartCapture}
                                    file={file}
                                    inputRef={inputRef}
                                    setFile={setFile}
                                    setScreenshot={setScreenshot}
                                    feedbackType={"ReportBug"}
                                />
                            </>
                        }
                    })}
                    <PrimaryButton children={PrimaryButtonText || 'Submit'} className='q-fdov-btn-continue' type='submit' style={buttonStyle} />
                </>
            ) : (
                <div className="q-center">
                    No data Found
                </div>
            )}
        </form>
    );
};

export default BugContent;
